import React from 'react'
import cn from 'classnames'
import Mask from '../../../components/Mask'
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import MoreButton from './MoreButton'
import IconTwitter from '../assets/icon-twitter.svg?svgr-webpack'
import IconInstagram from '../assets/icon-instagram.svg?svgr-webpack'
import IconYoutube from '../assets/icon-youtube.svg?svgr-webpack'
import IconFacebook from '../assets/icon-facebook.svg?svgr-webpack'
import { Link } from 'react-router-dom'
import Logo from 'js/components/Logo'

type NavLinkProps = {
  children: React.ReactNode
  to: string
}

const NavLink = ({ children, to, ...rest }: NavLinkProps) => (
  <Link
    className={cn(
      'type-upper mx-12 inline-block text-Type transition',
      'border-b-1 border-Border hover:border-Type',
    )}
    to={to}
    {...rest}
  >
    {children}
  </Link>
)

type SocialLinkProps = {
  type: 'youtube' | 'twitter' | 'instagram' | 'facebook'
}

const SocialLink = ({ type }: SocialLinkProps) => {
  let data
  switch (type) {
    case 'youtube':
      data = {
        link: 'https://www.youtube.com/channel/UCy64gY3TCURHxigExH0cHIg',
        name: 'YouTube',
        icon: IconYoutube,
      }
      break
    case 'twitter':
      data = {
        link: 'https://twitter.com/lifesum',
        name: 'Twitter',
        icon: IconTwitter,
      }
      break
    case 'instagram':
      data = {
        link: 'https://www.instagram.com/lifesum',
        name: 'Instagram',
        icon: IconInstagram,
      }
      break
    case 'facebook':
      data = {
        link: 'https://www.facebook.com/Lifesum',
        name: 'Facebook',
        icon: IconFacebook,
      }
      break
    default:
      break
  }

  return (
    <a
      href={data.link}
      className={`
          mx-8 flex h-48 w-48
          transform rounded-full 
          bg-white shadow-elevated transition
          hover:-translate-y-1
          lg:mx-12 lg:h-56 lg:w-56
        `}
    >
      <data.icon
        className="relative m-auto text-green lg:scale-110 lg:transform"
        style={data.name === 'Twitter' ? { left: 1, top: 1 } : {}}
      />
      <span className="sr-only">{data.name}</span>
    </a>
  )
}

const NutritionFooter = () => (
  <footer className="bg-BgSub text-center">
    <Mask>
      <div style={{ height: '6.15vw' }} className="bg-white" />
    </Mask>
    <div className="py-40 lg:py-64 xl:py-80">
      <Logo className="mb-24" />
      <div className="s-text mx-auto max-w-768">
        <p>
          Lifesum is one of the world’s leading nutrition specialists. We’re on
          a mission to make it easier for everyone to live a healthy life and
          make an impact on global wellness.
        </p>
        <p className="font-demibold">Healthy Living. Simplified.</p>
      </div>
      <ul className="mb-40 flex justify-center lg:mb-64">
        <li>
          <SocialLink type="youtube" />
        </li>
        <li>
          <SocialLink type="twitter" />
        </li>
        <li>
          <SocialLink type="instagram" />
        </li>
        <li>
          <SocialLink type="facebook" />
        </li>
      </ul>
      <nav className="pt-40 lg:pt-64">
        <ul className="flex justify-center">
          <li>
            <NavLink to="/nutrition-explained/experts/">Advisory board</NavLink>
          </li>
          <li>
            <NavLink to="/nutrition-explained/archive/1/">Archive</NavLink>
          </li>
        </ul>
      </nav>
    </div>
  </footer>
)

export default NutritionFooter
